import React, { useState } from 'react'
import { Card, CardBody, Col, Input, Row } from 'reactstrap'
import { Btn } from '../../../../../AbstractElements';
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan';
import TrendingPosts from './TrendingPosts';
import FollowUs from './FollowUs';
import RecentPosts from './RecentPosts';
import PopularTags from './PopularTags';
import Subscriber from './Subscriber';

export default function BlogSidebar() {
    const [open, setOpen] = useState(false)
    const blogToggle = () => {
        setOpen(!open);
    }
    return (
        <Col xxl={3} xl={4} className="blog-filter">
            <div className="md-sidebar">
                <Btn color='primary' className="email-aside-toggle md-sidebar-toggle" onClick={blogToggle}>{'Blog Filter'}</Btn>
                <div className={`md-sidebar-aside job-sidebar custom-scrollbar ${open ? 'open' : ''}`}>
                    <Row className="blog-sidebar">
                        <Col sm={12}>
                            <Card>
                                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading='Search' />
                                <CardBody>
                                    <div className="blog-search">
                                        <Input type="text" placeholder="Search here..." /><i className="fa fa-search" />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <TrendingPosts/>
                        <FollowUs/>
                        <RecentPosts/>
                        <PopularTags/>
                        <Subscriber/>
                    </Row>
                </div>
            </div>
        </Col>
    )
}